module.exports = __webpack_public_path__ + "static/media/bar profilo.6601f26e.svg";